import {
    UPCOMING_BOOKING_DETAILS_START,
    UPCOMING_BOOKING_DETAILS_SUCCESS,
    UPCOMING_BOOKING_DETAILS_ERROR,
    ONGOING_BOOKING_DETAILS_START,
    ONGOING_BOOKING_DETAILS_SUCCESS,
    ONGOING_BOOKING_DETAILS_ERROR,
    COMPLETED_BOOKING_DETAILS_START,
    COMPLETED_BOOKING_DETAILS_SUCCESS,
    COMPLETED_BOOKING_DETAILS_ERROR,
    CANCELLED_BOOKING_DETAILS_START,
    CANCELLED_BOOKING_DETAILS_SUCCESS,
    CANCELLED_BOOKING_DETAILS_ERROR,
    BOOKING_SUMMARY_DETAILS_START,
    BOOKING_SUMMARY_DETAILS_SUCCESS,
    BOOKING_SUMMARY_DETAILS_ERROR
} from "../Constant/BookingDetailConstants";

const initialState = {
    loading: false,
    upcomingDetail: [],
    ongoingDetail: [],
    completedDetail: [
        {
            "tour_name": "Dream Tour",
            "tour_start_point": "Pune",
            "tour_end_point": "Leh",
            "min_seat": "10",
            "max_seat": "20",
            "trip_increment": "IN10076-0001",
            "trip_start_date": "2022-01-07",
            "default_motorcycle_model": "BULLET 350",
            "additional_motorcycle_models": "HIMALAYAN",
            "customer_own_motorcycle": "1",
            "total_booking_on_re": 1,
            "booking_with_own_motorcycle": 0,
            "interests_registered": 0,
            "external_booking": "10",
            "is_otp_enable": false,
            "riders_listing": [
                {
                    "show_customer_details": false,
                    "booking_status": "upcoming",
                    "rider_id": "11",
                    "booking_id": "979",
                    "booking_series_id": "BT2100004",
                    "ride_type": "",
                    "rider_name": "",
                    "rider_email": "",
                    "rider_mobile": "",
                    "rider_mobile_code": "",
                    "rider_age": "0",
                    "rider_nationality": "",
                    "rider_gender": "",
                    "rider_food_preference": "",
                    "rider_allergy_condition": "",
                    "rider_emergency_contact_name": "",
                    "rider_emergency_contact_number": "",
                    "rider_emergency_contact_number_code": "",
                    "rider_emergency_relationship": "",
                    "rider_accommodation_type": "",
                    "rider_insurance": "https://rewanderlustuat.blob.core.windows.net/tour-docs/bookings/BT2100004/insurance/insurance-20211130183705.pdf",
                    "rider_indemnity": "https://rewanderlustuat.blob.core.windows.net/tour-docs/bookings/BT2100004/indemnity-form/indemnity-form-20211130183715.pdf",
                    "rider_id_proof": "https://rewanderlustuat.blob.core.windows.net/tour-docs/bookings/BT2100004/id-proof/id-proof-20211130183356.pdf",
                    "motorcycle_model_name": "",
                    "motorcycle_assigned_name": "CLASSIC 500 - DESERT STORM-MH02BA2551",
                    "motorcycle_assigned_id": "7326",
                    "vas_json": "",
                    "is_this_rider_apillion": "0",
                    "invoice_pdf": "",
                    "invoice_approval_id": ""
                }
            ]
        }
    ],
    cancelledDetail: [],
    bookingSummaryDetails: null
};


export default function BookingDetailReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case UPCOMING_BOOKING_DETAILS_START:
            return {
                ...state,
                loading: true,
            };
        case UPCOMING_BOOKING_DETAILS_SUCCESS:
            return {
                ...state,
                upcomingDetail: action.payload,
                loading: false,
            };
        case UPCOMING_BOOKING_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case ONGOING_BOOKING_DETAILS_START:
            return {
                ...state,
                loading: true,
            };
        case ONGOING_BOOKING_DETAILS_SUCCESS:
            return {
                ...state,
                ongoingDetail: action.payload,
                loading: false,
            };
        case ONGOING_BOOKING_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case COMPLETED_BOOKING_DETAILS_START:
            return {
                ...state,
                loading: true,
            };
        case COMPLETED_BOOKING_DETAILS_SUCCESS:
            return {
                ...state,
                completedDetail: action.payload,
                loading: false,
            };
        case COMPLETED_BOOKING_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case CANCELLED_BOOKING_DETAILS_START:
            return {
                ...state,
                loading: true,
            };
        case CANCELLED_BOOKING_DETAILS_SUCCESS:
            return {
                ...state,
                cancelledDetail: action.payload,
                loading: false,
            };
        case CANCELLED_BOOKING_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case BOOKING_SUMMARY_DETAILS_START:
            return {
                ...state,
                loading: true,
            };
        case BOOKING_SUMMARY_DETAILS_SUCCESS:
            return {
                ...state,
                bookingSummaryDetails: action.payload,
                loading: false,
            };
        case BOOKING_SUMMARY_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}